import {
  LIST_USERS,
  ADD_USER,
  DELETE_USER,
  GET_USER,
  USER_DETAIL_UPDATE_EMAIL_NOTIFICATION,
  USER_DETAIL_UPDATE_NEWSLETTER_NOTIFICATION,
} from '../actions/usersActions';
import { ApiUserListType, ApiUserType } from '../features/Users/types';

export type UserListType = {
  items: ApiUserListType;
  userDetail: ApiUserType;
  total: number;
};

export type UsersReducerActionType = {
  type: string;
  payload: UserListType | ApiUserType | string;
};

const defaultState = {
  items: [],
  userDetail: null,
  total: 0,
};

const usersReducer = (state = defaultState, action: UsersReducerActionType) => {
  switch (action.type) {
    case LIST_USERS:
      return action.payload;
    case ADD_USER:
      return {
        ...state,
        items: [action.payload, ...state.items],
      };
    case DELETE_USER:
      return {
        ...state,
        items: state.items.filter(({ id }) => id !== action.payload),
      };
    case GET_USER:
      return {
        ...state,
        userDetail: action.payload,
      };
    case USER_DETAIL_UPDATE_EMAIL_NOTIFICATION:
      return {
        ...state,
        userDetail: {
          ...state.userDetail,
          settings_v2: {
            ...state.userDetail.settings_v2,
            notification_email: {
              ...state.userDetail?.settings_v2.notification_email,
              [action.payload.key]: action.payload.checked,
            },
          },
        },
      };
    case USER_DETAIL_UPDATE_NEWSLETTER_NOTIFICATION:
      return {
        ...state,
        userDetail: {
          ...state.userDetail,
          settings_v2: {
            ...state.userDetail.settings_v2,
            newsletter: {
              ...state.userDetail?.settings_v2.newsletter,
              [action.payload.key]: action.payload.checked,
            },
          },
        },
      };
    default:
      return state;
  }
};

export default usersReducer;
